<template>
  <div>
    <div style="text-align:center;padding-top:10px;color:lightgray;padding-top:20px;padding-bottom:0px">
      <h6>Gadget Insurance Quote</h6>
    </div>
    <div>
      <v-stepper
        v-model="e1"   
        style="background-color:transparent;padding-top:0px;padding-bottom:0px" 
        dark
      >
        <v-stepper-header style="font-size:12px;padding-bottom:0px;padding-top:0px;color:lightgray">
          <v-stepper-step :complete="e1 > 1" step="1">Client Details</v-stepper-step>
          <v-divider></v-divider>          
          <v-stepper-step :complete="e1 > 2" step="2">Item Details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Quotation Details</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" style="height:380px">
            <div style="height:280px">
                <v-form ref="form1">
                  <v-row class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >                   
                      <v-text-field v-if="user.loggedIn"
                        placeholder="First name *"                        
                        v-model="user.data.first_name"                    
                        required
                        :rules="[v => !!v || 'This is a required field']"
                        dense            
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-right:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                      <v-text-field v-else
                        placeholder="First name *"                        
                        v-model="custom.first_name"                    
                        required
                        :rules="[v => !!v || 'This is a required field']"
                        dense            
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-right:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col>
                    <v-col 
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    > 
                      <v-text-field v-if="user.loggedIn"
                        placeholder="Last name *"
                        v-model="user.data.last_name"                      
                        required
                        :rules="[v => !!v || 'This is a required field']"
                        dense                       
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                      <v-text-field v-else
                        placeholder="Last name *"
                        v-model="custom.last_name"                      
                        required
                        :rules="[v => !!v || 'This is a required field']"
                        dense                       
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >    
                      <vue-phone-number-input
                        v-model="custom.phone_number" 
                        placeholder="Phone number"
                        default-country-code="ZM"
                        required
                        dark
                        @update="getPhoneNumber"
                        no-example
                        style="padding-right:5px"
                      />
                    </v-col>
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >   
                      <v-menu
                        :v-model="menu2"
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="computedDateFormatted"
                            placeholder="Effective date *"
                            readonly
                            required
                            outlined
                            background-color="rgb(66,66,66,0.85)"
                            @change="quote=true"
                            dense
                            :rules="[v => !!v || 'This is a required field']"
                            v-on="on"
                            style="padding-left:5px;color:lightgray;font-size:12px"
                          ></v-text-field>
                        </template>
                        <v-date-picker 
                          v-model="date" 
                          no-title 
                          @input="menu2 = false"
                          :allowed-dates="allowedDates"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >   
                      <v-text-field          
                        placeholder="Cover Period"
                        disabled
                        value="1 Year"
                        dense
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-right:5px;color:lightgray;font-size:12px"                             
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >   
                      <v-text-field
                        placeholder="Expiry date"
                        type="date"                        
                        dense   
                        disabled         
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"  
                        v-model="electronicsQuote.expiry_date"                    
                      >  
                      </v-text-field>
                    </v-col>
                  </v-row>   
                </v-form>
              </div>
              <v-divider></v-divider>
            <v-btn
              outlined
              text
              @click="validate(1);"
              style="color:lightgray;border:1px solid lightgray"
            >
              Continue
            </v-btn>
            <v-btn 
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
              text
              @click="closeProduct"
            >
              Cancel
            </v-btn>
          </v-stepper-content>
          <v-stepper-content step="2" style="height:380px">
            <div style="height:280px">
                <v-form class="ma-0 pa-0" ref="form2"> 
                  <v-row class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="2"
                    >                 
                      <v-select             
                        :items="category_list"
                        placeholder="Type"
                        item-text="text"
                        item-value="value"
                        v-model="category"
                        dense
                        return-object
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="color:lightgray;font-size:12px"          
                        :rules="[v => !!v || '*Required']"
                      >
                      </v-select>
                    </v-col>
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="2"
                    >  
                      <v-text-field
                        placeholder="Model"                         
                        v-model="make"
                        dense            
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px" 
                        :rules="[v => !!v || '*Required']"
                      >  
                      </v-text-field>
                    </v-col>
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="2"
                    >       
                      <v-text-field
                        placeholder="Serial #"                        
                        dense            
                        v-model="serial_no"    
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"  
                        :rules="[v => !!v || '*Required']"            
                      >  
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      class="ma-0 pa-0"
                    >             
                      <v-text-field
                        placeholder="Value"   
                        v-model="est_value"                       
                        dense
                        :rules="[v => !!v || '*Required']"
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"           
                      > 
                      </v-text-field>
                    </v-col> 
                    <v-col
                      cols="12"
                      sm="4"
                      class="ma-0 pa-0"
                    >   
                      <v-btn
                        text
                        outlined
                        @click="uploadPhotos()"
                        style="margin-left:5px;color:lightgray;border:1px solid lightgray;font-size:8px"
                      >
                        Upload Photos
                      </v-btn>          
                      <v-btn
                        text
                        outlined
                        @click="addItem()"
                        style="margin-left:5px;color:lightgray;border:1px solid lightgray;font-size:8px"
                      >
                        Save
                      </v-btn>
                    </v-col>       
                  </v-row>
                  <v-simple-table dense style="background-color:transparent" height="230px">
                  <thead>
                    <tr v-if="electronicsQuote.itemDetails != null">
                      <th class="text-left">Type</th>
                      <th class="text-left">Model</th>
                      <th class="text-left">Serial #</th>
                      <th class="text-left">Value</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item_details,index) in electronicsQuote.itemDetails"
                      :key="index"
                    >
                      <td style="font-size:10px">{{ item_details.category.text }}</td>
                      <td style="font-size:10px">{{ item_details.make }}</td>
                      <td style="font-size:10px">{{ item_details.serial_no }}</td>
                      <td style="font-size:10px">{{ item_details.est_value }}</td>
                      <td width="10%"><v-btn title="Delete item" small icon @click="deleteItem(index)"><v-icon>mdi-delete</v-icon></v-btn></td>
                    </tr>
                  </tbody>
                </v-simple-table>
            </v-form>
            </div>
            <v-divider></v-divider>
            <v-btn
              text
              outlined
              @click="e1 = 3;getPremium()"
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
            >
              Continue
            </v-btn>
            <v-btn 
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
              text
              @click="e1 = 1"
            >
              Previous
            </v-btn>
          </v-stepper-content>
          <v-stepper-content step="3" style="height:380px">
            <div style="height:280px">
                <v-form ref="form3"> 
                  <div style="color:white" class="pa-0 ma-0">Client Details</div>           
                <v-simple-table dense style="background-color:transparent" height="50px">
                  <thead>
                    <tr>
                      <th width="50%" v-if="user.loggedIn" class="text-left"> {{ user.first_name }} {{ user.last_name }} </th>
                      <th width="50%" v-else class="text-left"> {{ custom.first_name }} {{ custom.last_name }} </th>
                      <th v-if="user.loggedIn" class="text-left"> {{ user.data.email }} </th>
                      <th v-else class="text-left"> {{ custom.email_address }} </th>
                    </tr>
                  </thead>
                </v-simple-table>                 
              <div class="pa-0 ma-0" style="color:white">Item Details</div> 
                <v-simple-table dense style="background-color:transparent" height="120px">    
                  <thead>
                    <tr v-if="electronicsQuote.itemDetails != null">
                      <th class="text-left">Category</th>
                      <th class="text-left">Make/Model</th>
                      <th class="text-left">Serial #</th>
                      <th class="text-left">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item_details,index) in electronicsQuote.itemDetails"
                      :key="index"
                    >
                      <td style="font-size:10px">{{ item_details.category.text }}</td>
                      <td style="font-size:10px">{{ item_details.make }}</td>
                      <td style="font-size:10px">{{ item_details.serial_no }}</td>
                      <td style="font-size:10px">{{ item_details.est_value }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div style="color:white">Quotation Details</div>
                  <v-simple-table dense style="background-color:transparent" height="50px">
                    <thead>
                      <tr>
                        <th class="text-left">Cover</th>
                        <th class="text-left">Start</th>
                        <th class="text-left">Expiry</th>
                        <th class="text-left">Items</th>
                        <th class="text-left" style="color:yellow">Levy</th>
                        <th class="text-left" style="color:yellow">Premium</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="font-size:10px">Electronics</td>
                        <td style="font-size:10px">{{ electronicsQuote.start_date }}</td>
                        <td style="font-size:10px">{{ electronicsQuote.expiry_date }}</td>
                        <td v-if="electronicsQuote.itemDetails != null" style="font-size:10px">{{ electronicsQuote.itemDetails.length - 1 }} </td>
                        <td style="font-size:10px"><b>K {{ electronicsQuote.levy }}</b></td>
                        <td style="font-size:10px"><b>K {{ electronicsQuote.premium }}</b></td>
                      </tr>
                    </tbody>
                  </v-simple-table>  
                </v-form>
            </div>
            <v-divider></v-divider>                       
            <div style="display:inline-block">
              <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on }">
                    <v-btn text outlined style="margin-right:15px;margin-left:10px" dark v-on="on" @click="isPrimary=false">Make Payment</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Deliver Certificate?</v-card-title>
                    <v-card-text>We deliver Insurance Certificates and other policy documents to a location of your choosing at a fee.</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <CheckoutModal v-if="user.loggedIn"
                        color="primary"
                        :isProduction="isProduction"
                        :email="user.data.email"
                        :amount="parseFloat(electronicsQuote.premium)"
                        :reference="reference"
                        :isPrimary="isPrimary"
                        :rave-key="raveKey"
                        :callback="callback"
                        :close="close"
                        :currency="currency"
                        :country="country"
                        :payment_method="paymentMethod"
                        :delivery="delivery"
                      />
                      <CheckoutModal v-else
                        color="primary"
                        :isProduction="isProduction"
                        :email="custom.email_address"
                        :amount="parseFloat(electronicsQuote.premium)"
                        :reference="reference"
                        :isPrimary="isPrimary"
                        :rave-key="raveKey"
                        :callback="callback"
                        :close="close"
                        :currency="currency"
                        :country="country"
                        :payment_method="paymentMethod"
                        :delivery="delivery"
                      />
                      <v-btn color="green darken-1" style="margin-left:5px" outlined text @click="dialog = false;delivery=!delivery;isPrimary=true">YES</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
            <v-btn 
              text
              @click="e1 = 2"
              outlined
              style="margin-left:5px"
            >
              Previous
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
     </v-stepper>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import CheckoutModal from "@/components/modals/CheckoutModal.vue";
  import moment from 'moment';

  const raveKey = process.env.VUE_APP_RAVE_TEST_KEY;

  export default {
    name: 'GadgetsQuote',
    components: {
      CheckoutModal
    },
    data: () => ({
      e1: 1,
      steps: 3,
      category_list: [
        { text: 'Phones', value: '1' },
        { text: 'Laptops', value: '2' },
        { text: 'Games', value: '3' }
      ],
      category: {
        text: '',
        value: ''
      },
      make: '',
      serial_no: '',
      est_value: '',
      input_rules: [
       // v => v.length > 0 || 'This field is required'
      ],
      custom: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
        province: {
          text: '',
          value: ''
        },
        city: {
          text: '',
          value: ''
        },
        physical_address: '',
        delivery_date: '',
        delivery_time: '',
        coordinates: {
          latitude: '',
          longitude: ''
        },
      },
      dialog: false,
      isProduction: false,
      raveKey: raveKey,
      amount: "",
      currency: "ZMW",
      country: "ZM",
      paymentMethod: "",
      delivery: false,
      isPrimary: true,
      province_list: [
        { text: 'Lusaka', value: 'lsk' },
        { text: 'Copperbelt', value: 'cbt' }
      ],
      city_list: [
        { text: 'Lusaka', value: 'lsk' },
        { text: 'Ndola' , value: 'ndl' },
        { text: 'Kitwe', value: 'ktk' },
        { text: 'Chingola', value: 'cng' },
        { text: 'Luanshya', value: 'lya' },
        { text: 'Kalulushi', value: 'kls' },
        { text: 'Mufurila', value: 'muf' },
      ],
      loading: false,
      menu2: false,
      quote: false,
      date: new Date().toISOString().substr(0, 10),
    }),
    watch: {
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
      vertical () {
        this.e1 = 2
        requestAnimationFrame(() => this.e1 = 1) // Workarounds
      }
    },
    methods: {
      submit() {
        if (this.$refs.form.validate()){
          this.loading = true;
        }
      },
      validate(step){
        if (step == "1"){
          if (this.$refs.form1.validate()){
            this.e1 = parseInt(step) + 1;
          }
        }
        if (step == "2"){
          if (this.$refs.form2.validate()){
            this.e1 = parseInt(step) + 1;
          }
        }
      },
      getPhoneNumber(payload){
        this.user.data.phone_number = payload.formattedNumber;
      },
      allowedDates: val => moment(val).isSameOrAfter(new Date(), 'day'),
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      addItem(){        
        if (this.$refs.form2.validate()){          
          var total_value = parseFloat(this.electronicsQuote.total_value);
          var current_value = parseFloat(this.est_value);
          
          total_value = total_value + current_value;
          
          this.electronicsQuote.total_value = total_value.toFixed(2);

          var itemDetails = {
            'category' : {
              'text' : this.category.text,
              'value': this.category.value
            }, 
            'make' : this.make,
            'serial_no' : this.serial_no,
            'est_value' : this.est_value,
          }

          this.electronicsQuote.itemDetails.push(itemDetails);
          this.category = null,
          this.make = '',
          this.serial_no = '',
          this.est_value = ''
        }
      },
      deleteItem(index){                       
        var total_value = parseFloat(this.electronicsQuote.total_value);
        var current_value = parseFloat(this.electronicsQuote.itemDetails[index].est_value);
        
        total_value = total_value - current_value;
        
        this.electronicsQuote.total_value = total_value.toFixed(2);
        
        this.electronicsQuote.itemDetails.splice(index,1);
      },
      onInput (val) {
        this.steps = parseInt(val)
      },
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      closeProduct(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=true;
        this.components.nav_drawer.expand_on_hover=true;
      },
      getPremium(){      
        if (this.electronicsQuote.total_value != ''){
            var grossPrem = parseFloat(this.electronicsQuote.total_value) * 0.005;
            this.electronicsQuote.levy = (grossPrem * 0.03).toFixed(2);
            var totalPrem = parseFloat(grossPrem) + parseFloat(this.electronicsQuote.levy);            
          
            this.electronicsQuote.premium = totalPrem.toFixed(2);
        }
      },
      callback: function(response) {
        if (response.data.tx.status == "successful" &&  response.data.tx.chargeResponseCode === "00") {
            if (response.data.tx.fraud_status === "ok") {
              this.txref = response.tx.txRef
              alert(
                  `Authenticate your payment via our mobile app with this code: ${response.data.tx.txRef}`
              );
            }
        } else {
            alert("Your payment could not be processed. Please try again later");
        }
      },
      close: function(){}
    },
    updated(){
      if (this.date != null){
        this.electronicsQuote.start_date = this.date;
        var startDate = this.$moment(this.date);
        this.electronicsQuote.expiry_date = startDate.add(365,'d').format('YYYY-MM-DD');
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        electronicsQuote: "electronicsQuote",
        components: "components"
      }),
      reference() {
        let text = "";
        let possible =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 10; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
      },
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },
    created(){
      var options = {
        enableHighAccuracy: false,
        timeout: Infinity, 
        maximumAge: 0 
    
      }
      this.$getLocation(options)
      .then(coordinates => {
        this.custom.coordinates.latitude = coordinates.lat;
        this.custom.coordinates.longitude = coordinates.lng;
      });
      if (this.user.loggedIn){
        this.custom.phone_number = (this.user.data.phone_number).substr(4,13);
      }
      if (this.date != null){
        this.electronicsQuote.start_date = this.date;
        var startDate = this.$moment(this.date);
        this.electronicsQuote.expiry_date = startDate.add(365,'d').format('YYYY-MM-DD');
      }
    }
  }
</script>